import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DOWNLOAD_TYPE_MULTIPLE, DOWNLOAD_TYPE_SINGLE } from '~/features/deliverables/constants/DownloadFile';
import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';
import Switch from '@rio-cloud/rio-uikit/Switch';

interface DownloadTypeFormItemProps {
    value?: string;
    onChange: (option: string) => void;
    horizontal?: boolean;
    showAllOption?: boolean;
}

const DownloadTypeFormItem: React.FC<DownloadTypeFormItemProps> = ({
    value = DOWNLOAD_TYPE_MULTIPLE,
    onChange,
}) => {

    const handleOnChange = () => {
        if (value === DOWNLOAD_TYPE_MULTIPLE) {
            onChange(DOWNLOAD_TYPE_SINGLE);
        } else {
            onChange(DOWNLOAD_TYPE_MULTIPLE);
        }
    };

    return <div className={'margin-bottom-10  margin-top-10'}>
        <div>
            <label><FormattedMessage id={'intl-msg:multipleDownloads'}/></label>
            <OverlayTrigger
                key={1}
                placement={'right-start'}
                overlay={
                    <Tooltip id='tooltip' allowOnTouch>
                        <FormattedMessage id={'intl-msg:downloadType:canBeDownloaded'}/>
                    </Tooltip>
                }
            >
                <span className={'uikit-icon icon-exclamation-sign margin-left-5 text-color-info '}/>
            </OverlayTrigger>
        </div>
        <Switch onChange={handleOnChange} checked={value === DOWNLOAD_TYPE_MULTIPLE}/>
    </div>;
};

export default DownloadTypeFormItem;
